import type Price from "../models/Price";

export const CouponState = {
    VALID: "success",					// all parameters successfully checked
    NOT_FOUND: "notFound", 				// code wrong or out of scope
    NOT_AVAILABLE_YET: "notAvailableYet",		// before time range
    EXPIRED: "expired",				// out of time range
    NOT_ACTIVATED: "notActive",			// disabled
    NO_CONTINGENT: "outOfContingent",			// allowed count of redeems reached
    BELOW_REQUIRED_AMOUNT: "minOrderValue",	// does not reach required order amount

    isBelowRequiredAmount(couponState: string = "") {
        return this[couponState.toUpperCase()] === this.BELOW_REQUIRED_AMOUNT;
    },

    isValid(couponState: string = "") {
        return this[couponState.toUpperCase()] === this.VALID;
    }
};

export type Coupon = {
    coupon: {
        id: string,
        couponNo: {
            index: string,
        },
        code: string,
        displayValue: string,
        displayUnit: string,
        requiredOrderValue: Price,
        eligibleAmount: Price,
        description: ?string,
        validFrom: Date,
        validTo: Date,
    },
    couponState: CouponState.VALID | CouponState.NOT_FOUND | CouponState.NOT_AVAILABLE_YET | CouponState.EXPIRED |
        CouponState.NOT_ACTIVATED | CouponState.NO_CONTINGENT | CouponState.BELOW_REQUIRED_AMOUNT | null,
};
